import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  dragIcon: {
    // TODO: Remove !important once refera-ui lib fixes button's specificity
    paddingLeft: '0 !important',
    width: 'fit-content',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  indexRight: {
    marginLeft: '18px',
    borderRadius: '50%',
    backgroundColor: '#f6f6f6',
    width: '28px',
    height: '28px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
